import gql from 'graphql-tag';

export const ContributorPermissions = gql`
  query contributorPermissions($id: RecordID!) {
    hierarchyItem(id: $id) {
      ... on HierarchyAlbumFolderItem {
        id
        album_folder {
          id
          name
          creator: account {
            id
          }
        }
      }
      ... on HierarchyAlbumItem {
        id
        album {
          id
          name
          creator {
            id
          }
        }
      }
    }
    me {
      id
      contributor_hierarchy_items(
        hierarchy_item_id: $id
        return_album_folder: true
      ) {
        records {
          ... on IContributorHierarchyItem {
            id
            contributor_assignment {
              id
              upload_access
              dnp_access
              album_create_access
              view_access
              album {
                id
              }
              album_folder {
                id
              }
              upload_info {
                storage {
                  max
                  used
                }
                photo_finder {
                  credits_balance {
                    total
                  }
                  photo_finder_photos_count_pending_charge: photos_count(
                    pending_charge_only: true
                  )
                }
              }
            }
          }
        }
      }
    }
  }
`;
